import {
  ModuleMountInfo,
  SdkProvider,
  getInstanceInfo,
  SliceRegistrar,
} from '@deliveryhero/vendor-web-core';
import {ReactElement} from 'react';
import {
  AVAILABILITY_HIGH_DEMAND_MODE,
  FEATURE_FLAG_CACHE_EXPIRY_IN_MIN,
} from '../constants/FeatureFlag';
import {HEARTBEAT_INTERVAL} from '../constants/Intervals';
import {useApiGatewayUrl} from '../hooks/useApiGatewayUrl';
import {useFwFToken} from '../hooks/useFwFToken';
import availabilityStateSlice from '../slices/AvailabilityStateSlice';
import {AvailabilityEnablingDaemon} from './AvailabilityEnablingDaemon';
import {AvailabilityStateDaemon} from './AvailabilityStateDaemon';
import {HeartbeatDaemon} from './HeartbeatDaemon';

const flagKeys = [AVAILABILITY_HIGH_DEMAND_MODE];

export default function DaemonEntry({
  mountInfo,
}: {
  mountInfo: ModuleMountInfo;
}): ReactElement | null {
  const fwfToken = useFwFToken();
  const apiGatewayUrl = useApiGatewayUrl();
  const isWebView = getInstanceInfo().wrapperType === 'mobile-app';
  const isApiGatewayUrlDefined = apiGatewayUrl !== undefined;

  if (isWebView) {
    return null;
  }

  return (
    <SdkProvider
      baseUrl={apiGatewayUrl}
      mountInfo={mountInfo}
      appName="Availability Daemon"
      fwfToken={fwfToken}
      fwfSubscriptionKeys={flagKeys}
      fwfCacheTimeToLiveMins={FEATURE_FLAG_CACHE_EXPIRY_IN_MIN}
    >
      <SliceRegistrar slice={availabilityStateSlice}>
        <AvailabilityEnablingDaemon isApiGatewayUrlDefined={isApiGatewayUrlDefined} />
        <AvailabilityStateDaemon />
        <HeartbeatDaemon interval={HEARTBEAT_INTERVAL} />
      </SliceRegistrar>
    </SdkProvider>
  );
}
